import { PrepaidWalletDetailsResponse } from '@ancon/wildcat-types'

import { FlattenPrepaidWalletDetails } from '../types'

export default function getFlattenWalletFromDetailsResponse(
  response: PrepaidWalletDetailsResponse,
): FlattenPrepaidWalletDetails {
  const { prepaidWallet, walletDiscount, soldOutlet } = response

  return {
    ...prepaidWallet,
    discountName: walletDiscount?.name || null,
    soldOutletName: soldOutlet?.name || '',
    soldOutletColor: soldOutlet?.color || null,
  }
}
